import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import SearchField from "../components/layouts/SearchField";
import Header from "../components/layouts/Header";
import InspectionCard from "../components/home/InspectionCard";
import InspectionDetail from "../components/home/InspectionDetail";
import SurveyorInfo from "../components/home/SurveyorInfo";
import InspectionList from "../components/home/InspectionList";
import { Icon } from "@iconify/react";
import InspectionModal from "../components/home/InspectionModal";
import { api } from "../services/api-service";
import { useDispatch, useSelector } from "react-redux";
import {
  addSurvey,
  getMySurveys,
  surveySelector,
  surveysSelector,
} from "../redux/surveySlice";
import { resetInspection } from "../redux/inspectionSlice";
import { userSelector } from "../redux/authSlice";
import Footer from "../components/layouts/Footer";
import NoSurvey from "./NoSurvey";

const Home = () => {
  const dispatch = useDispatch();
  const searchTimeout = useRef();
  const user = useSelector(userSelector);
  const survey = useSelector(surveySelector);
  const surveys = useSelector(surveysSelector);
  // const [surveys, setSurveys] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      getSurveys(1);
    }, 500);
  }, [search]);

  const getSurveys = async (pageNum) => {
    dispatch(getMySurveys({ user, search }));
  };

  return (
    <>
      <Header text={search} onChange={(e) => setSearch(e)} />
      <div className="main">
        <Container fluid>
          <Row>
            <Col lg="3">
              <div class="d-none d-md-block searchSurvey">
                <SearchField text={search} onChange={(e) => setSearch(e)} />
              </div>
              <div class="surveyListHeight">
                {!surveys.data?.length > 0 && (
                  <NoSurvey
                    type={
                      search ? "No survey found" : "No surveys assigned yet!"
                    }
                    text={
                      search
                        ? "Try searching something else"
                        : "There are no surveys assigned to you at this moment. Please contact admin for any assistance"
                    }
                  />
                )}
                {surveys?.data?.map((desc, index) => (
                  <InspectionCard key={index} survey={desc} />
                ))}
              </div>
            </Col>
            <Col lg="6">
              <InspectionDetail />
            </Col>
            <Col lg="3">
              <div className="mb-lg-3 rightMainWrapper">
               <div className="d-none d-lg-block"> 
                  <SurveyorInfo />
                </div>
                {survey.id && <InspectionList showAdd={true} />}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Home;
